var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Injectable, Inject } from '@angular/core';
import { CONFIGURE_SETTINGS_STORE } from '../configure-settings-store';
var ConfigureSettingsLoadingHandler = /** @class */ (function () {
    function ConfigureSettingsLoadingHandler(configureSettingsStore) {
        this.configureSettingsStore = configureSettingsStore;
    }
    ConfigureSettingsLoadingHandler.prototype.execute = function (configureId) {
        var _this = this;
        return this.configureSettingsStore.load(configureId).then(function () {
            $(window).bind('unload', function () {
                _this.configureSettingsStore.save();
            });
        });
    };
    ConfigureSettingsLoadingHandler = __decorate([
        Injectable(),
        __param(0, Inject(CONFIGURE_SETTINGS_STORE))
    ], ConfigureSettingsLoadingHandler);
    return ConfigureSettingsLoadingHandler;
}());
export { ConfigureSettingsLoadingHandler };
